import { render, staticRenderFns } from "./OrganizationUserList.vue?vue&type=template&id=f54bd7b2&scoped=true&"
import script from "./OrganizationUserList.vue?vue&type=script&lang=ts&"
export * from "./OrganizationUserList.vue?vue&type=script&lang=ts&"
import style0 from "./OrganizationUserList.vue?vue&type=style&index=0&id=f54bd7b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f54bd7b2",
  null
  
)

export default component.exports